import { useEffect, useState } from 'react';

// True once `active` has stayed true for `delay` milliseconds; false again as soon as it isn't.
export default function useDelayedFlag(active, delay) {
	const [elapsed, setElapsed] = useState(false);

	useEffect(() => {
		if(!active) {
			setElapsed(false);
			return undefined;
		}
		const timer = setTimeout(() => setElapsed(true), delay);
		return () => clearTimeout(timer);
	}, [active, delay]);

	return active && elapsed;
}
